import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { PFRow } from '../components';

const List = styled.div`
  height: auto;
  overflow: scroll;
`;

const PFList = ({ theme, txs }) => (
  <ThemeProvider theme={theme}>
    <List>{txs.map(tx => <PFRow tx={tx} key={tx.id} />)}</List>
  </ThemeProvider>
);

export default withTheme(PFList);



// WEBPACK FOOTER //
// ./src/components/PFList.js